export const BRANDING = "branding";
export const DESIGN = "design";
export const PRINTING = "printing";
export const ADVERTISING = "advertising";
export const DIGITAL = "digital";
export const PHOTOVIDEO = "photovideo";
export const WEB = "webdevelopment"